import { Component, Input, OnInit } from "@angular/core";

import { FormGroup } from "@angular/forms";
import { MatFormFieldControl } from "@angular/material/form-field";
import { FormatPhonePipe } from "@app/shared/resources/phone-formatter.pipe";

@Component({
    selector: "phone-input",
    templateUrl: "./phone-input.component.html",
    styleUrls: ["./phone-input.component.scss"],
    providers: [{ provide: MatFormFieldControl, useExisting: PhoneInputComponent }],
})
export class PhoneInputComponent implements OnInit {
    @Input() theForm: FormGroup;
    @Input() field: string;
    @Input() label: string;
    @Input() notRequired: string;
    @Input() isFullWidthField = false;

    public metadata = {
        patternMatch: [
            {
                name: "validPhone",
            },
        ],
        inputName: null,
        type: "text",
        friendlyName: null,
    };

    ngOnInit() {
        this.metadata.inputName = this.field;
        this.metadata.friendlyName = this.label;
    }

    blurHandler() {
        const theField = this.theForm.controls[this.field];
        const phoneParts = (theField.value || "").match(/([+()-.\s0-9]+)/) || [null, theField.value || ""];

        let formattedVal = "";

        if (phoneParts) {
            const digits = phoneParts[1].replace(/[()-. ]/g, "") || "";

            if (digits.length >= 10) {
                formattedVal = new FormatPhonePipe().transform(digits, "x (xxx) xxx-xxxx");
            } else {
                formattedVal = digits;
            }
        }

        theField.setValue(formattedVal, { emitEvent: false });
    }
}
